import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      offset={16}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:w-[calc(100vw-2rem)] sm:group-[.toaster]:w-[26rem] group-[.toaster]:rounded-2xl group-[.toaster]:border group-[.toaster]:border-stone-300 group-[.toaster]:bg-white group-[.toaster]:px-4 group-[.toaster]:py-3 group-[.toaster]:text-charcoal group-[.toaster]:shadow-[0_16px_36px_rgba(41,37,36,0.18)]",
          title:
            "font-body text-[0.98rem] font-semibold leading-snug !text-charcoal",
          description:
            "font-body text-[0.9rem] leading-snug !text-stone-800",
          actionButton:
            "group-[.toast]:h-9 group-[.toast]:rounded-full group-[.toast]:bg-charcoal group-[.toast]:px-4 group-[.toast]:font-body group-[.toast]:text-sm group-[.toast]:font-medium group-[.toast]:text-warm-white",
          cancelButton:
            "group-[.toast]:h-9 group-[.toast]:rounded-full group-[.toast]:bg-stone-200 group-[.toast]:px-4 group-[.toast]:font-body group-[.toast]:text-sm group-[.toast]:font-medium group-[.toast]:text-charcoal",
          closeButton:
            "group-[.toast]:border-stone-300 group-[.toast]:bg-white group-[.toast]:text-stone-500 group-[.toast]:hover:text-charcoal",
          success:
            "group-[.toaster]:border-emerald-200 group-[.toaster]:bg-emerald-50",
          error:
            "group-[.toaster]:border-rose-200 group-[.toaster]:bg-rose-50",
          warning:
            "group-[.toaster]:border-amber-200 group-[.toaster]:bg-amber-50",
          info:
            "group-[.toaster]:border-sky-200 group-[.toaster]:bg-sky-50",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
